import React from 'react';
import { useRouter } from 'next/router';
import { Box } from '@hub/box';
import { H3 } from '@hub/heading';
import { CentreSelector } from '../../components/centre-selector';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const centreSelectorConfig = {
  inputLabel: 'Search by centre',
  locationLabel: 'Or use your current location',
  suggestedCentresLabel: 'Suggested Centres',
  id: 'banner-centre-selector'
};
export const FindACentreBanner = _ref => {
  let {
    centres,
    searchTerm
  } = _ref;
  const searchPath = useRouter().asPath;
  const heading = "Looking for '".concat(searchTerm, "' in a Westfield Centre?");
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      width: 'size-full',
      backgroundColor: 'smoke',
      padding: 0
    },
    "data-id": "find-a-centre-banner_index_FindACentreBanner_Box",
    children: /*#__PURE__*/_jsxs(Box, {
      sx: {
        maxWidth: 'fit-content',
        margin: '0 auto',
        padding: 'spacing-4'
      },
      "data-id": "find-a-centre-banner_index_FindACentreBanner_Box_Box_1",
      children: [/*#__PURE__*/_jsx(H3, {
        "data-id": "find-a-centre-banner_index_FindACentreBanner_Box_H3",
        children: heading
      }), /*#__PURE__*/_jsx(CentreSelector, {
        centres: centres,
        navStyle: style,
        searchPath: searchPath,
        config: centreSelectorConfig,
        "data-id": "find-a-centre-banner_index_FindACentreBanner_Box_CentreSelector"
      })]
    })
  });
};